import Layout from '@layout/Index'

export const hr = [
  {
    path: '/hr',
    component: Layout,
    children: [
      {
        path: 'employee',
        component: () => import(/* webpackChunkName: "employee" */ './pages/employee/list'),
        name: '员工管理',
        meta: {
          title: '员工管理',
        },
      },
      {
        path: 'employee/add',
        component: () => import(/* webpackChunkName: "employee-add" */ './pages/employee/form'),
        name: '员工新增',
        meta: {
          title: '员工新增',
        },
      },
      {
        path: 'employee/update/:id',
        component: () => import(/* webpackChunkName: "employee-update" */ './pages/employee/form'),
        name: '员工编辑',
        meta: {
          title: '员工编辑',
        },
      },
      {
        path: 'employee/detail/:id',
        component: () => import(/* webpackChunkName: "employee-detail" */ './pages/employee/form'),
        name: '员工详情',
        meta: {
          title: '员工详情',
          isOnlyView: true, // 只是查看
        },
      },
      {
        path: 'employee/birthday-list',
        component: () => import(/* webpackChunkName: "birthday-list" */ './pages/employee/birthday-list'),
        name: '查看生日祝福',
        meta: {
          title: '查看生日祝福',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/hr/hr.route.js